import { FC, useEffect } from "react";
import { FormControl, Stack, TextField } from "@mui/material";
import { TimeTableExtensionProps } from "./TimeTable.tsx";
import { v7 } from "uuid";

export type PreOrderExtensionValues = {
  maxOrders: number;
  maxOrderValue: number;
};

export const PreOrderExtension: FC<TimeTableExtensionProps<PreOrderExtensionValues>> = ({
  openingHours,
  data,
  onChange,
  defaultValue,
}) => {
  useEffect(() => {
    if (data == null && defaultValue != null) {
      onChange({
        id: v7(),
        hours: openingHours.hours,
        data: defaultValue,
      });
    }
  }, [data, defaultValue, onChange, openingHours]);
  return (
    <Stack direction={"row"} gap={1}>
      <FormControl sx={{ ".MuiFormControl-root": { my: 1 } }}>
        <TextField
          type={"number"}
          label={"Orders per slot"}
          value={data?.maxOrders ?? defaultValue.maxOrders}
          onChange={(e) => {
            onChange({
              ...openingHours,
              data: {
                maxOrders: Number(e.target.value),
                maxOrderValue: data?.maxOrderValue ?? defaultValue.maxOrderValue,
              },
            });
          }}
          sx={{
            maxWidth: "120px",
            my: 2,
          }}
        />
      </FormControl>

      <FormControl sx={{ ".MuiFormControl-root": { my: 1 } }}>
        <TextField
          type={"number"}
          label={"Max order value"}
          value={data?.maxOrderValue ?? defaultValue.maxOrderValue}
          onChange={(e) =>
            onChange({
              ...openingHours,
              data: {
                maxOrders: data?.maxOrders ?? defaultValue.maxOrders,
                maxOrderValue: Number(e.target.value),
              },
            })
          }
          sx={{
            maxWidth: "120px",
            my: 2,
          }}
        />
      </FormControl>
    </Stack>
  );
};
